import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { Table } from 'primeng/table';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { ComponentCausedFailurerDTO } from '../../model/component-caused-failure.entity';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';

@Component({
  selector: 'tandc-component-caused-failure',
  templateUrl: './component-caused-failure.component.html',

})
export class ComponentCausedFailureComponent implements OnInit {

  componentCausedFailureList: ComponentCausedFailurerDTO[] = [];
  componentCausedFailureModel: ComponentCausedFailurerDTO = new ComponentCausedFailurerDTO();
  showModal: boolean = false;
  modalTitle: string = "";
  @ViewChild('dt')
  dt!: Table;

  constructor(private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
    private masterDataRepository: MasterDataRepository) { }

  ngOnInit(): void {
    this.getAll();
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  getAll() {
    this.service.getComponentCausedFailure().subscribe((x) => {
      this.componentCausedFailureList = x.value;
    })
  }

  addModal() {
    this.componentCausedFailureModel = new ComponentCausedFailurerDTO();
    this.showModal = !this.showModal;
    this.modalTitle =
      this.translate.instant('commonbtn.add') +
      ' Component Caused Failure';
  }

  save(data: ComponentCausedFailurerDTO) {
    if (data.id > 0) {
      this.service.updateComponentCausedFailure(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.UpdatedSuccessfully')
          );
          this.getAll();
        }
      });
    } else {
      this.service.saveComponentCausedFailure(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.SavedSuccessfully')
          );
          this.getAll();
        }
      });
    }
  }

  delete(data: ComponentCausedFailurerDTO) {
    this.commonService.confirmationService.confirm({
      message: this.translate.instant('Alerts.DeleteConfirmation'),
      accept: () => {
        if (data) {
          this.service.deleteCompomemtCausedFailure(data.id).subscribe((res) => {
            if (res) {
              this.commonService.successMessage(
                this.translate.instant('Alerts.DeleteSuccessfully')
              );
              this.getAll();
            }
          });
        }
      },
    });
  }

  onToggleStatus(item: ComponentCausedFailurerDTO) {
  const updatedItem = { ...item }; 
  this.service.updateComponentCausedFailure(updatedItem).subscribe({
    next: () => {
      this.commonService.successMessage(
        this.translate.instant('Alerts.UpdatedSuccessfully')
      );
    },
    error: () => {
      this.commonService.errorMessage(
        this.translate.instant('Alerts.ErrorOccured')
      );
      // Revert toggle on error
      item.isActive = !item.isActive;
    }
  });
  }

  edit(data: ComponentCausedFailurerDTO) {
    this.modalTitle = this.translate.instant('common.update') + ' Component Caused Failure';
    this.componentCausedFailureModel = data;
    this.showModal = !this.showModal;
  }

  downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  export() {
    this.masterDataRepository.export('component-caused-failure').subscribe(blob => {
      this.downloadFile(blob, `component-caused-failure-${new Date().toISOString().slice(0,10)}.xlsx`);
    });
  }

}
